<template>
  <div class="tabs-component">
    <ul role="tablist" class="tabs-component-tabs">
      <li
          v-for="(tab, i) in tabs"
          :key="i"
          :class="{ 'is-active': tab.isActive, 'is-disabled': tab.isDisabled }"
          class="tabs-component-tab"
          v-show="tab.isVisible"
      >
          <a v-html="tab.name"
              :aria-controls="tab.computedId"
              :aria-selected="tab.isActive"
              @click="selectTab(tab.computedId, $event)"
              class="tabs-component-tab-a"
              role="tab"
          ></a>
      </li>
    </ul>
    <div class="tabs-component-panels">
        <slot/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'tabs',
  data: () => ({
      tabs: []
  }),
  created() {
      this.tabs = this.$children;
  },
  mounted() {
    if (this.tabs.length) {
        this.selectTab(this.tabs[0].computedId);
    }
  },
  methods: {
      selectTab(selectedTab, event) {
        this.tabs.forEach(tab => {
          tab.isActive = (tab.computedId === selectedTab);
        });
      }
  }
};
</script>
